import { isNil } from "@sunrise/utils";
import { atomWithSuspenseQuery } from "jotai-tanstack-query";
import { ngChannelApiAtom } from "@sunrise/backend-ng-channel";

import { atomFamily } from "jotai/utils";
import { ChannelId } from "@sunrise/backend-types-core";

/**
 * Unused, but it's a good example of how to use the ngChannelApiAtom.
 */
export const channelForChannelIdQueryAtom = atomFamily((id: ChannelId) => {
  return atomWithSuspenseQuery((get) => {
    const api = get(ngChannelApiAtom);
    if (isNil(api)) {
      throw new Error("ngChannelApiAtom is not initialized");
    }

    return {
      // TODO: also extract queryKeys to a shared place.
      //       These should actually be shared between ng and legacy. But maybe legacy ones can be prefixed.
      queryKey: ["channels", id],
      queryFn: async () => {
        const r = await api.channel.channelDetailChannelV1ChannelsChannelIdGet(
          id,
        );

        return r.data;
      },
    };
  });
});
